<template>
  <div class="mobile-wrapper" v-if="storeMenu">
    <!-- <Coupons />-->
    <shop-header :store-id="storeid" :categories="storeMenu.Categories" />
    <div class="content-padding-double" />
    <div class="container-fluid mobile-menu-content">
      <ProductList :menu="JSON.parse(JSON.stringify(storeMenu))" />
    </div>
  </div>
</template>
<script>
import ProductList from "./products/ProductListMobile";
import ShopHeader from "./partials/shopheaderMobile";
import { mapMutations, mapActions, mapGetters } from "vuex";
export default {
  components: {
    ProductList,
    ShopHeader
  },
  props: {
    storeid: {
      type: String,
      default: ""
    }
  },
  data() {
    return {};
  },
  async created() {
    this.initPriceTriggers(this.storeid);
  },
  mounted() {
    this.setStore(this.storeid);
    this.initStore(this.storeid);
    this.getStoreMenu(this.storeid);
    if (!sessionStorage.getItem("paymenttype")) {
      sessionStorage.setItem(
        "paymenttype",
        new URLSearchParams(window.location.search).get("paymenttype")
      );
    }
  },
  computed: {
    ...mapGetters(["storeMenu"])
  },
  methods: {
    ...mapMutations(["setStore"]),
    ...mapActions([
      "initStore",
      "getStoreMenu",
      "insertErrorlog",
      "redirectToErrorPage",
      "initPriceTriggers"
    ])
  }
};
</script>
